import { PropTypes } from 'prop-types'

import { IconButton, Icon } from '@chakra-ui/react'
import { LuChevronUp } from 'react-icons/lu'

export const UpButton = ({ onClick, ...props }) => {
  return (
    <IconButton variant="solid" onClick={onClick} colorPalette="primary" size="md" borderRadius="full" zIndex="tooltip" aria-label="Scroll to top" {...props}>
      <Icon as={LuChevronUp} boxSize="1.5rem" />
    </IconButton>
  )
}

UpButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}
